<template>
  <div class="icon-list">
    <!-- something went wrong -->
    <div
      class="icon-list__item"
      v-for="params in displayList"
      :key="params.icon"
    >
      <button
        class="icon-list__btn"
        type="button"
        @click="handleIconAdd(params)"
      >
        <icon-renderer
          :params="params"
          effectId="test"
          class="icon-list__icon"
        />
      </button>
      <a-popover placement="rightTop" overlayClassName="shape-menu-overlay">
        <template slot="content">
          <p class="shape-menu-overlay__name">{{ params.icon }}</p>
          <p class="shape-menu-overlay__desc">可用风格: {{ params.allThemes }}</p>
        </template>
        <a-button class="material-action-trigger" type="link">
          <a-icon type="ellipsis" />
        </a-button>
      </a-popover>
    </div>
  </div>
</template>
<script>
import iconList, { themeNames } from '../../utils/iconList';
import IconRenderer from '../player/IconRenderer';

const allIcons = {
  Fill: [],
  Outline: [],
  TwoTone: []
};

Object.keys(iconList).forEach(k => {
  const themes = iconList[k];
  themes.forEach(t => {
    allIcons[t].push({
      width: 40,
      height: 40,
      theme: t,
      allThemes: themes.map(v => themeNames[v]).join(', '),
      icon: k,
      color: 'var(--color)',
      secondaryColor: 'var(--secondary)'
    });
  });
});

export default {
  props: ['keyword', 'theme'],
  computed: {
    iconList() {
      return allIcons[this.theme];
    },
    displayList() {
      return this.keyword ? this.iconList.filter(item => {
        return new RegExp(this.keyword.replace(/([[\]^$?.*/+|\\()])/g, '\\$1'), 'i').test(item.icon);
      }) : this.iconList;
    }
  },
  components: { IconRenderer },
  methods: {
    handleIconAdd(item) {
      this.$store.dispatch('addIconItem', item);
    }
  },
  mounted() {
    console.log(this.iconList);
  }
}
</script>
<style scoped>
.icon-list {
  display: flex;
  flex-wrap: wrap;
  margin-right: -14px;
}

.icon-list__item {
  flex-shrink: 0;
  width: calc(100% / 3 - 14px);
  margin-right: 14px;
  margin-top: 11px;
  font-size: 12px;
  --color: #616161;
  --secondary: #e4e4e4;
  position: relative;
}

.icon-list__item:hover .material-action-trigger {
  opacity: 0.7;
}

.icon-list__item .material-action-trigger:hover,
.icon-list__item .material-action-trigger:focus {
  opacity: 1;
}

.icon-list__btn {
  background: #fff;
  margin-bottom: 4px;
  padding: 0 0 100%;
  position: relative;
  transition: 0.2s;
  width: 100%;
  display: block;
  border: 0;
  outline: 0;
  border-radius: 0;
  cursor: pointer;
}

.icon-list__btn:hover,
.icon-list__btn:focus {
  color: #007eff;
  --color: #007eff;
  --secondary: #cce8ff;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.icon-list__btn:active {
  box-shadow: 0 0 0 transparent, inset 0 0 6px rgba(0, 0, 0, 0.1);
}

.icon-list__icon {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  transition: fill 0.3s;
}
</style>